import { z } from 'zod'

export const ProductPriceFormSchema = z.object({
  price: z.coerce
    .number({
      invalid_type_error: 'Price must be a number',
      required_error: 'Price is required',
    })
    .positive({
      message: 'Price must be positive',
    })
    .multipleOf(0.01, {
      message: 'Price must have at most 2 decimal places',
    }),
  taxRate: z.coerce.number().optional().nullable(),
  validFrom: z.string().optional().nullable(),
  note: z.string().optional().nullable(),
})

export type ProductPriceFormValues = z.infer<typeof ProductPriceFormSchema>
